import React, { useEffect, useState } from "react";
import {
  DefaultPrimaryButton,
} from "../../../components/micro/input";
import Breadcrumb from "../../../components/common/BreadCrumb";
import { ArrowNext, DownArrow } from "../../../assets/svg";
import Action from "../../../components/common/Action";
import CustomTable from "../../../components/customTable/CustomTable";
import ServicingModal from "../components/ServicingModal";
import { useLocation } from "react-router-dom/dist";
import { getServiceSchedulingById } from "../../../redux/service/slice";
import { useDispatch, useSelector } from "react-redux";
import RippleLoader from "../../../components/loader/RippleLoader";
import DebounceSearch from "../../../components/common/DebounceSearch";
import ViewServiceReport from "../servicereport/ViewServiceReport";

const ViewScheduling = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const serviceData =
    location?.state?.schedule || getServiceSchedulingData?.data[0];
  const [isListVisible, setIsListVisible] = useState(true);
  const [isQuotationOpen, setIsQuotationOpen] = useState(true);
  const [isReceiptOpen, setIsReceiptOpen] = useState(true);
  const [nextUpcomingList, setNextUpcomingList] = useState([]);
  const [completedServicesList, setCompletedServicesList] = useState([]);
  const [selectedOutletName, setSelectedOutletName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [selectedSaleId, setSelectedSaleId] = useState(null);
  const [isModal, setIsModal] = useState(false);

  // Selector
  const { getServiceSchedulingData, loading } = useSelector((store) => ({
    getServiceSchedulingData:
      store?.serviceData?.getServiceSchedulingByIdStatus?.data?.data,
    loading: store?.serviceData?.getServiceSchedulingByIdStatus?.loading,
  }));

  useEffect(() => {
    if (serviceData?.id) {
      dispatch(getServiceSchedulingById({ id: serviceData.id }));
    }
  }, [serviceData?.id]);

  const openModal = (mode) => {
    setModalMode(mode);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const filteredOutlets = serviceData?.company_outlets?.filter((outletData) =>
    outletData?.outlet?.name?.toLowerCase().includes(searchValue?.toLowerCase())
  );

  const DataRows = () => (
    <>
      {nextUpcomingList?.map((element, index) => (
        <tr
          key={index}
          className="font-normal text-sm shadow-sm text-mgrey font-Proxima"
        >
          <td className="px-5 py-3">{index + 1}</td>
          <td className="px-5 py-3">{element?.technician || "-"}</td>
          <td className="px-5 py-3">{element?.range || "-"}</td>
          <td className="px-5 py-3 ">{element?.dateTime || "-"}</td>
          <td className="flex px-5 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => openModal("scheduled")}
                  >
                    Reschedule
                  </li>
                </>
              }
            />
          </td>
        </tr>
      ))}
    </>
  );

  const SecondDataRows = () => (
    <>
      {completedServicesList?.map((element, index) => (
        <tr key={index} className="font-normal text-sm shadow-sm text-mgrey ">
          <td className="px-5 py-3">{index + 1}</td>
          <td className="px-5 py-3">{element?.outlet_name}</td>
          <td className="px-5 py-3 ">{element?.dateTime}</td>
          <td className="px-5 py-3 truncate">{element?.technician}</td>
          <td className="flex px-5 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => {
                      setSelectedSaleId([element?.service_report_id]);
                      setIsModal(true);
                    }}
                  >
                    View Service Report
                  </li>
                </>
              }
            />
          </td>
        </tr>
      ))}
    </>
  );

  return (
    <>
      <div>
        <div>
          <h6 className="font-Montserrat font-medium text-xl mb-3">
            Service Request
          </h6>
          <Breadcrumb
            breadCrumbParent={"Home"}
            breadCrumbParent2={"Service Request Scheduling"}
            breadCrumbActive={serviceData?.company}
            breadCrumbTitleKey={"/"}
            classes=""
          />
        </div>
        <div className="pt-3 flex justify-between items-center">
          <p className="text-2xl font-Montserrat font-normal">
            "{serviceData?.company}" | Contract Services
          </p>
          <DefaultPrimaryButton
            value="Create Servicing"
            onClick={() => openModal("unscheduled")}
          />
        </div>

        {loading ? (
          <RippleLoader />
        ) : (
          <>
            {/* requeswt info div */}
            <div className="w-full mb-3 mt-3">
              <div className="bg-white p-6 rounded-lg shadow-md w-full shadow-borderDot  border border-borderDot">
                <div className="flex justify-between items-center">
                  <div>
                    <h2 className="text-xl font-medium font-Montserrat text-mgrey">
                      Request Information:
                    </h2>
                    <p className="text-themeBtn text-base font-normal font-Proxima">
                      Total Servicing Count: {serviceData.totalCount}
                    </p>
                    <p className="text-themeBtn text-xl font-medium font-Proxima">
                      Total Servicing Count Left:{" "}
                      {serviceData?.totalServicesCountLeft}
                    </p>
                    <p className="text-mgrey text-base font-normal">
                      Technician: “{serviceData.technicians}”
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-textSecondary text-sm text-left font-normal">
                      Year: 2024
                    </p>
                    <p className="text-textSecondary text-sm text-left font-normal">
                      Created On: 24/04/2024 | 13:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* info second div */}
            <div className="flex gap-3">
              {/* left side */}
              <div className="w-[30%]">
                {/* outlet */}
                <div className="max-w-sm mx-auto my-4 p-4 bg-white shadow-lg rounded-lg border border-borderDot">
                  <div className="mb-4 border-b border-b-mGray pb-4 ">
                    <div className="flex justify-between items-center mb-2">
                      <h2 className="text-sm font-normal text-mgrey ">
                        Outlets ({serviceData?.company_outlets?.length})
                      </h2>
                      <button onClick={() => setIsListVisible(!isListVisible)}>
                        <DownArrow
                          className={`transform transition-transform duration-300 ${
                            isListVisible ? "rotate-180" : "rotate-0"
                          }`}
                        />
                      </button>
                    </div>
                    <DebounceSearch
                      placeholder="Search..."
                      search={searchValue}
                      handleChange={setSearchValue}
                      className="w-full"
                    />
                  </div>
                  {isListVisible && (
                    <div className="space-y-2">
                      {filteredOutlets?.map((outletData, index) => {
                        const outlet = outletData?.outlet;
                        return (
                          <div
                            key={outlet?.id}
                            className="p-4 rounded-lg bg-white hover:bg-primaryGray"
                            onClick={() => {
                              setNextUpcomingList(outletData?.upcomingServices);
                              setCompletedServicesList(
                                outletData?.completedServices
                              );
                              setSelectedOutletName(outlet?.name);
                            }}
                          >
                            <div className="flex justify-between items-center">
                              <div className="flex gap-2 items-center">
                                <div>
                                  <span className="font-normal text-sm text-mgrey">
                                    {index + 1}
                                  </span>
                                </div>
                                <div className="mt-1">
                                  <p className="font-normal text-sm text-mgrey">
                                    {outlet?.name}
                                  </p>
                                  <p className="font-normal text-xs text-mgrey">
                                    {outlet?.address}
                                  </p>
                                  <p className="font-normal text-xs text-mgrey">
                                    {outlet?.postal_code}
                                  </p>
                                </div>
                              </div>
                              <div className="text-xs text-textSecondary text-left flex">
                                <div>
                                  <p>Last Service:</p>
                                  <p>{outlet?.lastServiceDateTime}</p>
                                </div>
                                <div className="cursor-pointer items-center flex">
                                  <ArrowNext />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
              {/* right side */}
              {(nextUpcomingList?.length > 0 ||
                completedServicesList?.length > 0) && (
                <div className="w-[70%] mt-4">
                  <div className="mb-4">
                    <p className="text-xl text-black font-medium">
                      {selectedOutletName}
                    </p>
                  </div>

                  {/* first */}
                  <div className="bg-white p-6 rounded-lg shadow-md mb-6 border border-borderDot">
                    <div className="bg-successGreen rounded p-3 flex justify-between items-center">
                      <p className="text-md font-normal text-mgrey">
                        Next Upcoming Servicing{" "}
                      </p>
                      <div className="cursor-pointer">
                        <button
                          onClick={() => setIsQuotationOpen(!isQuotationOpen)}
                        >
                          <DownArrow
                            className={`transform transition-transform duration-300 ${
                              isQuotationOpen ? "rotate-180" : "rotate-0"
                            }`}
                          />
                        </button>
                      </div>
                    </div>
                    {isQuotationOpen && (
                      <div className="mt-2">
                        <CustomTable
                          dataRows={<DataRows />}
                          data={nextUpcomingList}
                          overflowVisibleLg={true}
                          loading={false}
                          showPagination={false}
                          shadowShow={true}
                        />
                      </div>
                    )}
                  </div>

                  {/* second */}
                  <div className="bg-bgGrey p-6 rounded-lg shadow-md mb-6 border border-borderDot">
                    <div className="bg-background_grey rounded p-3 flex justify-between items-center">
                      <p className="text-md font-normal text-mgrey">
                        Completed Servicing Request
                      </p>
                      <button onClick={() => setIsReceiptOpen(!isReceiptOpen)}>
                        <DownArrow
                          className={`transform transition-transform duration-300 ${
                            isReceiptOpen ? "rotate-180" : "rotate-0"
                          }`}
                        />
                      </button>
                    </div>
                    {isReceiptOpen && (
                      <div className="mt-2">
                        <CustomTable
                          backgroundColor={true}
                          dataRows={<SecondDataRows />}
                          data={completedServicesList}
                          overflowVisibleLg={true}
                          loading={false}
                          showPagination={false}
                          shadowShow={true}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {isModalOpen && (
        <ServicingModal
          onClose={closeModal}
          modalMode={modalMode}
          data={getServiceSchedulingData?.data[0]}
        />
      )}
      {isModal && (
        <div>
          <ViewServiceReport
            onClose={() => {
              setIsModal(false);
            }}
            selectedSaleId={selectedSaleId}
            schedule
          />
        </div>
      )}
    </>
  );
};

export default ViewScheduling;
